<template>
  <section id="user-list">
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="filters"
          title="Filtros"
          class="form-filters"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="refreshStop('cardAction')"
        >
          <b-row>
            <b-col cols="3">
              <b-form-group
                label="Nome / E-mail / Telefone / Id"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="filtersValues.name_or_email"
                  @keyup.enter="getUsers"
                  @keyup="refreshNameFilter"
                />
                <small class="d-block text-right">{{ applyFilterIn }}</small>
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group
                label="Tipo"
                label-for="filter_type"
              >
                <b-form-select
                  id="filter_type"
                  v-model="filtersValues.type"
                  :options="filtersOptions.type"
                />
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group
                label="Status"
                label-for="filter_status"
              >
                <b-form-select
                  id="filter_status"
                  v-model="filtersValues.status"
                  :options="filtersOptions.status"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="3"
              class="form-buttons"
            >
              <b-form-group
                label=""
                label-for="btn-buscar"
                style="margin-top: 20px"
              >
                <b-button
                  id="btn-buscar"
                  variant="primary"
                  @click="searchAndResetPage"
                >
                  Buscar
                </b-button>

                <b-button
                  id="btn-limpar"
                  variant="outline-secondary"
                  @click="reset()"
                >
                  Limpar
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-actions>

        <b-card>
          <b-row
            class="header-card"
            align-v="center"
          >
            <b-col>
              <h4>
                Resultados
              </h4>
            </b-col>

            <b-col class="text-right">
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-table
                :busy="isLoading"
                fixed
                :items="results"
                :fields="result_fields"
                sort-icon-left
                no-local-sorting
                :sort-by.sync="filtersValues.sortBy"
                :sort-desc.sync="filtersValues.sortDesc"
                @sort-changed="sortingChanged"
              >
                <template #table-busy>
                  <div class="text-center table-spinner">
                    <b-spinner label="Loading..." />
                    <strong>Carregando...</strong>
                  </div>
                </template>

                <template #head(type)>
                  <div class="text-nowrap">
                    Tipo
                  </div>
                </template>

                <template #head(status)>
                  <div class="text-nowrap">
                    Status
                  </div>
                </template>

                <template #head(id)>
                  <div class="text-nowrap">
                    Responsável
                  </div>
                </template>

                <template #head(contact)>
                  <div class="text-nowrap">
                    Contatos
                  </div>
                </template>

                <template #head(created_at)>
                  <div class="text-nowrap">
                    Cadastrado em
                  </div>
                </template>

                <template #head(modules)>
                  <div class="text-nowrap">
                    Módulos
                  </div>
                </template>

                <template #head(actions)>
                  <div class="text-nowrap text-center">
                    Ações
                  </div>
                </template>

                <template #cell(id)="row">
                  {{ row.item.id }}<br>
                  {{ row.item.name }}<br>
                  <b-badge
                    :variant="row.item.person_type === 'pj' ? 'light-warning' : 'light-info'"
                  >
                    {{ $t(`commercia.users.columns.person_type.${row.item.person_type}`) }}
                  </b-badge>
                </template>

                <template #cell(contact)="row">
                  <div
                    v-if="row.item.list_emails"
                  >
                    <span
                      v-for="email in row.item.list_emails"
                      :key="`email-${email.id}`"
                      class="multiple-lines"
                    >
                      {{ email.email }}
                      <feather-icon
                        v-if="email.verified_at"
                        animation="spin-pulse"
                        class="text-success"
                        icon="CheckIcon"
                        :title=" `Confirmado em ${formatDateTimeDbToView(email.verified_at)}` "
                      />
                    </span>
                  </div>
                  <div
                    v-if="row.item.emails_cms"
                  >
                    <span
                      v-for="(emailcms, k) in row.item.emails_cms"
                      :key="`emailcms-${k}`"
                      class="multiple-lines"
                    >
                      {{ emailcms }}
                    </span>
                  </div>

                  <div
                    v-if="row.item.list_phones"
                  >
                    <span
                      v-for="phone in row.item.list_phones.filter(f => f.number !== 0)"
                      :key="`phone-${phone.id}`"
                      class="multiple-lines"
                    >
                      {{ `${phone.ddd}${phone.number}` | formatPhone }}
                      <feather-icon
                        v-if="phone.verified_at"
                        animation="spin-pulse"
                        class="text-success"
                        icon="CheckIcon"
                        :title=" `Confirmado em ${formatDateTimeDbToView(phone.verified_at)}` "
                      />
                    </span>
                  </div>
                  <div
                    v-if="row.item.phones_cms"
                  >
                    <span
                      v-for="(phonecms, k) in row.item.phones_cms"
                      :key="`phonecms-${k}`"
                      class="multiple-lines"
                    >
                      {{ phonecms }}
                    </span>
                  </div>
                </template>

                <template #cell(created_at)="row">
                  {{ formatDateTimeDbToView(row.item.created_at) }}
                </template>

                <template #cell(modules)="row">
                  <div v-if="row.item.is_module_hafidme">
                    <b-badge
                      pill
                      variant="light-primary"
                    >
                      Hafidme
                    </b-badge>

                    <span v-if="row.item.deleted_at === null">
                      {{ $t(`users.columns.status.${row.item.hafidme_status}`) }}
                    </span>
                    <div v-else>
                      <span class="text-danger">REMOVIDO</span>
                    </div>
                  </div>

                  <div
                    v-if="row.item.is_module_crm"
                  >
                    <b-badge

                      pill
                      variant="light-success"
                    >
                      Crm
                    </b-badge>
                  </div>
                </template>

                <template #cell(actions)="row">
                  <div class="text-nowrap text-center">
                    <b-button
                      v-if="$can('read', 'Users')"
                      variant="flat-primary"
                      :to="{ name: 'cms-user-form-update', params: { id: row.item.id } }"
                      title="Editar"
                      target="_blank"
                    >
                      <feather-icon
                        icon="EditIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>

                    <b-button
                      v-if="$can('delete', 'Users')"
                      variant="flat-primary"
                      title="Deletar"
                      :disabled="row.item.deleted_at !== null"
                      @click="deleteUser(row.item.id)"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>
                  </div>
                </template>

                <template #row-details="row">
                  <b-spinner v-if="!row.item.message" />
                  <p>{{ row.item.message }}</p>
                </template>

              </b-table>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <p>Mostrando {{ pages.from }} até {{ pages.to }} de {{ pages.total }} resultados</p>
            </b-col>

            <b-col cols="6">
              <!-- pagination nav -->
              <b-pagination-nav
                v-model="currentPage"
                :number-of-pages="pages.last_page"
                :link-gen="() => { return '#' }"
                align="end"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>

    </b-row>

  </section>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import UserService from '@/services/userService'
import CommerciaService from '@/services/commerciaService'
import { formatDateTimeDbToView } from '@/utils/helpers'
// import moment from 'moment'
import {
  BRow,
  BCol,
  BTable,
  BBadge,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BPaginationNav,
  BSpinner,
  BButton,
  // BModal,
  BCard,
  BBreadcrumb,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  userTypes, userStatus,
} from '@/utils/options'

export default {
  components: {
    BCardActions,
    BCard,
    BRow,
    BBadge,
    BCol,
    BTable,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BPaginationNav,
    BSpinner,
    BButton,
    // BModal,
    BBreadcrumb,
    // vSelect,
  },

  data() {
    return {
      userService: null,
      isLoading: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Usuários',
          active: true,
        },
      ],

      nameFilter: '',
      applyFilterIn: '',
      filtersInitialValues: {},
      filtersValues: {
        name_or_email: '',
        type: 'all',
        status: 'all',
        sortBy: 'id',
        sortDesc: true,
      },
      filtersOptions: {
        status: [
          { value: 'all', text: 'Todos' },
          ...userStatus,
        ],
        type: [
          { value: 'all', text: 'Todos' },
          ...userTypes,
        ],
      },

      pages: 1,
      currentPage: 1,
      results: [],
      result_fields: [],
      formatDateTimeDbToView,
    }
  },

  watch: {
    currentPage() {
      this.getUsers()
    },
  },

  created() {
    this.userService = new UserService()
    this.getUsers()
    this.filtersInitialValues = { ...this.filtersValues }

    this.result_fields = [
      { key: 'id', sortable: true },
      { key: 'contact', sortable: false },
      // { key: 'phone', sortable: true, thStyle: 'width: 150px' },
      // { key: 'email', sortable: true },
      { key: 'created_at', sortable: true, thStyle: 'width: 150px' },
      { key: 'modules', sortable: false, thStyle: 'width: 230px' },
    ]

    if (this.showActions()) {
      this.result_fields.push({ key: 'actions', sortable: false, thStyle: 'width: 150px' })
    }
  },

  methods: {
    reset() {
      this.filtersValues = JSON.parse(JSON.stringify(this.filtersInitialValues))
      this.getUsers()
    },

    searchAndResetPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.getUsers()
      }
    },

    sortingChanged(ctx) {
      this.filtersValues.sortBy = ctx.sortBy
      this.filtersValues.sortDesc = ctx.sortDesc
      this.getUsers()
    },

    showActions() {
      return this.$can('read', 'Users') || this.$can('update', 'Users') || this.$can('delete', 'Users')
    },

    deleteUser(userId) {
      this.$swal({
        title: 'Deletar usuário?',
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, deletar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.isLoading = true
          this.userService.delete(userId).then(response => {
            this.isLoading = false
            if (response.status === 200) {
              this.results = this.results.filter(filter => filter.id !== userId)
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Usuário ${userId} removido!`,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                  // text: `!`,
                },
              })
            }
          })
        }
      }).catch(error => {
        this.isLoading = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro!',
            text: error.response.data.message,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      })
    },

    refreshNameFilter(e) {
      let applyFilterIn = ''
      const { value } = e.target
      if (value.replace(/[^0-9]/, '').length === value.length) {
        applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} ID`
        if (value.length >= 6) {
          applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} Telefone, CPF e CNPJ`
        }
      } else if (value.replace(/[@.]/, '').length !== value.length) {
        applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} E-mail`
      } else {
        applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} Nome, E-mail`
      }

      this.applyFilterIn = `Pesquisa no campo: ${applyFilterIn}`
    },

    getUsers() {
      this.isLoading = true

      CommerciaService.list(this.filtersValues, this.currentPage).then(response => {
        this.results = response.data.data.users.data.map(m => ({
          ...m,
          list_phones: m.list_phones.sort((a, b) => (a.main < b.main ? 1 : -1)),
          list_emails: m.list_emails.sort((a, b) => (a.main < b.main ? 1 : -1)),
        }))
        this.pages = {
          ...response.data.data.users,
          data: null,
        }
      }).finally(() => {
        this.isLoading = false
      })

      /*
      this.userService.list(this.filtersValues, this.currentPage).then(response => {
        if (response.data !== null) {
          const users = response.data.data.users.data.map(
            m => ({
              ...m,
              plan_group_name: (m.last_plan !== null) ? m.last_plan.split(',')[0] : '',
              payment_interval: (m.last_plan !== null) ? m.last_plan.split(',')[1] : '',
              list_phones: m.list_phones.sort((a, b) => (a.master < b.master ? 1 : -1)),
              list_emails: m.list_emails.sort((a, b) => (a.master < b.master ? 1 : -1)),
            }),
          )
          this.results = users

          this.pages = response.data.data.users
          delete this.pages.data
        }
        this.isLoading = false
      })

       */
    },

  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  #user-list {
    .b-table{
      td{
        padding: 0.5rem 1rem;
      }
    }

    .multiple-lines{
      display:block;
    }

    .multiple-lines-email{
      margin-top: 5px;
      display:block;
    }

    .header-card {
      margin-bottom: 20px;
    }

    .form-buttons button {
      margin-right: 10px;
    }
  }
</style>
